import { render, staticRenderFns } from "./NotificationContainer.vue?vue&type=template&id=7bc866b2&scoped=true"
import script from "./NotificationContainer.vue?vue&type=script&lang=js"
export * from "./NotificationContainer.vue?vue&type=script&lang=js"
import style0 from "./NotificationContainer.vue?vue&type=style&index=0&id=7bc866b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc866b2",
  null
  
)

export default component.exports